import React, { useEffect, useState } from "react";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export default function PurchaseAndSaleData({
  product,
  handleProductChange,
  registerFromDeliveryNote,
  family,
}) {
  const [ivaList, setIvaList] = useState([]);

  async function getIVAList() {
    const response = await post("ListarTiposIVA.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
    });
    const list = response.tiposIVA.map((e) => ({
      id: e,
      text: e.toString(),
    }));
    setIvaList(list);
  }

  async function getIVA() {
    const response = await post("ObtenerTipoIVA.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      familia: family,
    });
    if (response.tipoIVA) {
      handleProductChange("iva", response.tipoIVA);
    }
  }

  useEffect(() => {
    getIVAList();
    if (product.id === -1) {
      getIVA();
    }
  }, []);

  useEffect(() => {
    if (product.iva === "") {
      getIVA();
    }
  }, [product.iva]);

  return (
    <div className="cell combined-cells-5">
      <div
        className="opt-table-content grid-8"
        id="advanced-product-content-grid"
      >
        <div className="cell cell-label">
          {!registerFromDeliveryNote ? "PCN" : "PCB"}
        </div>
        <div className="cell">
          <InputData
            tabIndex={525}
            type="type-float2"
            size={0}
            input={!registerFromDeliveryNote ? product.pcn : product.pcb}
            onChange={(e) => {
              handleProductChange(!registerFromDeliveryNote ? "pcn" : "pcb", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">IVA</div>
        <div className="cell">
          <Dropdown
            mandatory={true}
            optionList={ivaList}
            size={0}
            op={product.iva}
            onChange={(e) => {
              handleProductChange("iva", e.text);
            }}
          ></Dropdown>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">PVP</div>
        <div className="cell">
          <InputData
            tabIndex={528}
            type="type-float2"
            size={0}
            input={product.pvp}
            onChange={(e) => {
              handleProductChange("pvp", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label">Stock</div>
        <div className="cell combined-cells-4">
          <InputData
            tabIndex={526}
            type="type-integer"
            size={0}
            input={product.stock}
            onChange={(e) => {
              handleProductChange("stock", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">PVP recomendado</div>
        <div className="cell">
          <InputData
            tabIndex={529}
            type="type-float2"
            size={0}
            input={product.pvpRecomendado}
            onChange={(e) => {
              handleProductChange("pvpRecomendado", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label">Sin control de stock</div>
        <div className="cell combined-cells-7">
          <div
            className="data-field c-pointer"
            onClick={() => {
              handleProductChange("sinControlStock", !product.sinControlStock);
            }}
          >
            <CheckBox
              tabIndex={527}
              active={product.sinControlStock}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
      </div>
    </div>
  );
}
